import { format } from 'date-fns';

export function dateTimeFormatter(date) {
  return format(new Date(date), 'MM/dd/yy h:mm aaa');
}
